import { callApi } from './api';

import { Office, CreateOfficeRequest } from '@/types/office';

export const createOffice = async (requestBody: CreateOfficeRequest) => {
  const { status, result } = await callApi<Office>(
    'offices',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
